import React from 'react';
import { DocumentIcon, FolderIcon } from '@heroicons/react/24/outline';

const PdfIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-red-600">
    <rect width="24" height="24" rx="4" fill="#F87171"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">PDF</text>
  </svg>
);

const WordIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-blue-700">
    <rect width="24" height="24" rx="4" fill="#2563EB"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">DOC</text>
  </svg>
);

const ExcelIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-green-600">
    <rect width="24" height="24" rx="4" fill="#22C55E"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">XLS</text>
  </svg>
);

const PowerPointIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-orange-600">
    <rect width="24" height="24" rx="4" fill="#EA580C"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">PPT</text>
  </svg>
);

const CsvIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-green-500">
    <rect width="24" height="24" rx="4" fill="#4ADE80"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">CSV</text>
  </svg>
);

const TxtIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-gray-500">
    <rect width="24" height="24" rx="4" fill="#A3A3A3"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">TXT</text>
  </svg>
);

const RtfIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-gray-600">
    <rect width="24" height="24" rx="4" fill="#6B7280"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">RTF</text>
  </svg>
);

const ImageIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-purple-500">
    <rect width="24" height="24" rx="4" fill="#A855F7"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">IMG</text>
  </svg>
);

const VideoIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-red-500">
    <rect width="24" height="24" rx="4" fill="#EF4444"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">VID</text>
  </svg>
);

const AudioIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-pink-500">
    <rect width="24" height="24" rx="4" fill="#EC4899"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">AUD</text>
  </svg>
);

const HtmlIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-orange-500">
    <rect width="24" height="24" rx="4" fill="#F59E42"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">HTML</text>
  </svg>
);

const XmlIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-blue-500">
    <rect width="24" height="24" rx="4" fill="#3B82F6"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">XML</text>
  </svg>
);

const JsonIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-yellow-500">
    <rect width="24" height="24" rx="4" fill="#EAB308"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">JSON</text>
  </svg>
);

const ZipIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-yellow-600">
    <rect width="24" height="24" rx="4" fill="#FBBF24"/>
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">ZIP</text>
  </svg>
);

export const fileTypeIcons: Record<string, React.ReactNode> = {
  folder: <FolderIcon className="h-5 w-5 text-yellow-500" />,
  document: <DocumentIcon className="h-5 w-5 text-blue-500" />,
  pdf: <PdfIcon />,
  doc: <WordIcon />,
  docx: <WordIcon />,
  xls: <ExcelIcon />,
  xlsx: <ExcelIcon />,
  ppt: <PowerPointIcon />,
  pptx: <PowerPointIcon />,
  csv: <CsvIcon />,
  txt: <TxtIcon />,
  rtf: <RtfIcon />,
  html: <HtmlIcon />,
  htm: <HtmlIcon />,
  edoc: <HtmlIcon />,
  xml: <XmlIcon />,
  json: <JsonIcon />,
  zip: <ZipIcon />,
  // Imagens
  jpg: <ImageIcon />,
  jpeg: <ImageIcon />,
  png: <ImageIcon />,
  gif: <ImageIcon />,
  bmp: <ImageIcon />,
  svg: <ImageIcon />,
  tiff: <ImageIcon />,
  webp: <ImageIcon />,
  // Vídeos
  mp4: <VideoIcon />,
  avi: <VideoIcon />,
  mov: <VideoIcon />,
  wmv: <VideoIcon />,
  flv: <VideoIcon />,
  webm: <VideoIcon />,
  mkv: <VideoIcon />,
  // Áudios
  mp3: <AudioIcon />,
  wav: <AudioIcon />,
  ogg: <AudioIcon />,
  aac: <AudioIcon />,
  flac: <AudioIcon />,
  wma: <AudioIcon />,
  // Arquivos compactados
  '7z': <ZipIcon />,
  rar: <ZipIcon />,
  tar: <ZipIcon />,
  gz: <ZipIcon />,
  bz2: <ZipIcon />,
};

export function getFileTypeIcon(type: string) {
  const icon = fileTypeIcons[type] || fileTypeIcons['document'];
  
  return icon;
} 